import { Component, Prop, Vue } from 'vue-property-decorator'
import { KTable } from '@kwixeo/table-vue'
import { mapGetters } from 'vuex'

@Component({
  components: {
    KTable
  },
  computed: {
    ...mapGetters('user', ['can'])
  }
})
export default class CustomersSales extends Vue {
  can!: (key: string, level: number) => boolean

  @Prop({ required: true }) type!: string
  @Prop({ required: true }) id!: number

  get ajaxUrl (): string {
    return '/catalog/' + this.type + '/' + this.id + '/customers'
  }

  get columns (): KwixeoTable.Columns {
    const columns: KwixeoTable.Columns = [
      {
        data: 'customer',
        name: this.$t('catalog.statistics.tables.customer')
      },
      {
        data: 'quantity',
        name: this.$t('catalog.statistics.tables.quantity'),
        render: 'amount'
      },
      {
        data: 'total_ht',
        name: this.$t('catalog.statistics.tables.totalHt'),
        render: 'currency'
      },
      {
        data: 'total_tva',
        name: this.$t('catalog.statistics.tables.totalTva'),
        render: 'currency',
        visible: false
      },
      {
        data: 'total_ttc',
        name: this.$t('catalog.statistics.tables.totalTtc'),
        render: 'currency',
        visible: false
      }
    ]

    if (this.can('sales-margin', 1)) {
      columns.push(...[
        {
          data: 'total_catalog_costs',
          name: this.$t('catalog.statistics.tables.buyPrice'),
          render: 'currency',
          visible: this.type === 'product'
        },
        {
          data: 'total_various_costs',
          name: this.$t('catalog.statistics.tables.variousCosts'),
          render: 'currency',
          visible: false
        },
        {
          data: 'total_costs',
          name: this.$t('catalog.statistics.tables.totalCosts'),
          render: 'currency',
          visible: false
        }
      ])
    }

    if (this.type === 'service') {
      columns.push(...[
        {
          data: 'total_duration_hour',
          name: this.$t('catalog.statistics.tables.duration'),
          render: 'amount'
        },
        {
          data: 'total_workforce',
          name: this.$t('catalog.statistics.tables.workforce'),
          render: 'amount'
        },
        {
          data: 'total_charge',
          name: this.$t('catalog.statistics.tables.charge'),
          render: 'currency',
          visible: false
        }
      ])
    }

    if (this.can('sales-margin', 1)) {
      columns.push({
        data: 'gross_margin_amount',
        name: this.$t('catalog.statistics.tables.grossMargin'),
        render: 'currency'
      })
    }

    return columns
  }

  get filters (): KwixeoTable.FiltersOption {
    return [
      {
        type: 'period',
        label: this.$t('catalog.statistics.tables.period'),
        name: 'since',
        name2: 'until'
      }
    ]
  }
}
